<template>
  <div class="upload-session" @mouseover="showTooltip = true" @mouseleave="showTooltip = false">
    <div class="status-item d-flex justify-content-between align-items-start">
      <div class="session-progress flex-grow-1">
        <CLink class="name" @click="routeToGallery">
          <CIcon size="custom-size" :height="14" name="cipFolderBlue" class="mr-1" style="vertical-align: baseline" />
          {{ session.gallery.name }}
        </CLink>
        <SessionProgress v-if="session.status !== uploadSessionStatus.failed"
                         :processed_count="session.processed_count"
                         :received_count="session.received_count"
                         :uploaded_count="session.uploaded_count"
                         :intents_count="session.intents_count"
                         :uploaded_size="session.uploaded_size"
                         :total_size="session.total_size"
        />
        <div class="info">
          <slot></slot>
        </div>
        <div v-if="hasFailedFiles" class="failed-alert mt-1">
          <slot name="failed-alert"></slot>
        </div>
      </div>
      <div class="ml-2 mt-1">
        <CButtonClose @click="onClose" class="list-item-closer" v-if="showCloseButton">
          <CIcon name="cipClose" size="custom-size" width="15"/>
        </CButtonClose>
        <CButtonClose @click="onConfirm" class="list-item-closer text-success" v-if="showConfirmButton">
          <CIcon name="cipCheck" size="custom-size" width="15"/>
        </CButtonClose>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import SessionProgress from "@/domain/uploader/components/SessionProgress.vue";
import uploadSessionStatus from "@/domain/core/constant/uploadSessionStatus";

export default {
  name: "UploadSession",
  components: {SessionProgress},
  emits: ['close', 'confirm'],
  props: {
    session: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      showTooltip: false
    }
  },
  computed: {
    ...mapGetters('uploader', ['picaServiceId']),
    uploadSessionStatus() {
      return uploadSessionStatus
    },
    hasFailedFiles() {
      return this.session.files && this.session.files.failed && this.session.files.failed.length > 0
    },
    showCloseButton() {
      // Show X for active uploads, failed, and also when there are failed files in completed uploads
      return [uploadSessionStatus.inProgress, uploadSessionStatus.empty, uploadSessionStatus.pending, uploadSessionStatus.failed].includes(this.session.status) ||
             this.hasFailedFiles
    },
    showConfirmButton() {
      // Show checkmark only when completed without any failed files
      return [uploadSessionStatus.uploaded, uploadSessionStatus.received, uploadSessionStatus.processed].includes(this.session.status) &&
             !this.hasFailedFiles
    }
  },
  methods: {
    async routeToGallery() {
      await this.$router.push({
        name: `eventWizard.gallery.browse_photo`, params: {
          galleryId: this.session.gallery.id,
          picaServiceId: this.picaServiceId
        }
      })
    },
    onClose() {
      this.$emit('close')
    },
    onConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>
